export default __webpack_public_path__ + "images/3f4fb40edb9e9b77b268d577159f5b45.png";